/**
 * Matches an address-like string containing letters, digits, spaces, and common address punctuation.
 *
 * [#.\da-zA-Zs, ]+
 * Character class matching one or more of:
 * - #
 * - .
 * - \d (amy digit 0-9)
 * - a-zA-Z (uppercase and lowercase)
 * - s
 * - ,
 * - space
 *
 * e.g. matching "123 Main st", "Apt #48", "456 Elm St", "Suite 2", "45s B St.", "456 Elm St, Suite 2"
 * e.g. failing "123%", "PO Box *123", "Main\tSt"
 */
var REGEX_ADDRESS = /^[#.\da-zA-Zs, ]+$/;
/**
 * Matches an address-like string containing letters, digits, spaces, and common address punctuation.
 *
 * - ^$ Matches an empty string
 * - | OR
 * - (?![0-9]+$) Negative lookahead: fails if the string is only digits
 * - [#.\da-zA-Zs,$`~!@#+= ] Matches one or more of following chars:
 * - # . , $ ` ~ ! @ + =
 * - \d (amy digit 0-9)
 * - a-zA-Z (uppercase and lowercase)
 * - s
 * - space
 *
 * e.g. matching "123 Main st", "#48", "456 Elm St", "Suite 5, $100", "Unit 7a!", "`Apt + 1`", "abc123"
 * e.g. failing "123", "!!*()@", "  ", "Main-St", "Suite\n5", "PO_Box"
 */
var REGEX_ADDRESS2 = /^$|^(?![0-9]+$)[#.\da-zA-Zs,$`~!@#+= ]+$/;
/**
 * [0-9]* Matches 0 (e.g. empty string) or more digits (0-9)
 * e.g. "", "0", "123456" NOT "12a", " 123", "123.45"
 */
var REGEX_NUMBERS = /^[0-9]*$/;
/**
 * [0-9]* Matches 0 (e.g. empty string) or more digits (0-9) along with a decimal (for income)
 * e.g. "", "0", "123456" or "1000.00"
 */
var REGEX_PADDED_INCOME = /^(?:\d+(?:\.\d{1,2})?)?$/;
/**
 * [A-Za-z ]+ Matches a string that only contains uppercase or lowercase letters and spaces (1 or more of)
 * e.g. "John", "Alice Smith", "a B c" NOT "John5", "hello!", ""
 */
var REGEX_ALPHABETS = /^[A-Za-z ]+$/;
/**
 * [0-9]* Matches 0 (e.g. empty string) or more digits (0-9)
 * e.g. "", "0", "123456" NOT "12a", " 123", "123.45"
 */
/**
 * A practical regular expression to validate standard email addresses
 * Follows sypi API regex while remaining geared towards RFC 5322 Standard
 *
 * Differs from sypi API by:
 * Have full email and domain label lengths
 * Not allow domains prefixed or suffixed with a hyphen.
 *
 * email, local, and domain max lengths covered individually in validateEmail utility function.
 *
 * Regex Breakdown:
 * [a-zA-Z0-9_-]+
 * Local part one or more alphanumerics or `_-`
 *
 * (?:\.[a-zA-Z0-9_-]+)*
 * Optional dot-separated segments (e.g. John.Doe)
 *
 * @
 * "@"" symbol Required
 *
 * (?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+
 * One or more domain segments up to 63 chars (e.g. mail.to.example.) cannot be prefixed or suffixed with a '-'
 *
 * [a-zA-Z]{1,10}
 * Top Level Domain 1-10 characters (e.g. com, org, net)
 */
var REGEX_EMAIL = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{1,10}$/;
/**
 * This is a utility regex that helps to test that the email local part (before @ symbol) does not only include "_" or '-'
 * This helps enforces the rule of local part containing at least one letter or digit.
 */
var REGEX_EMAIL_LOCAL_INVALID_CONDITION = /^[_-]+$/;
export { REGEX_ADDRESS, REGEX_ADDRESS2, REGEX_ALPHABETS, REGEX_NUMBERS, REGEX_PADDED_INCOME, REGEX_EMAIL, REGEX_EMAIL_LOCAL_INVALID_CONDITION, };
